export default __webpack_public_path__ + "static/media/knowledge-base-cover.0cc6d16a.jpg";